exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form[data-v-8a6a2b0c] {\n  text-align: left;\n}\n.forgot-button[data-v-8a6a2b0c] {\n  float: right;\n}\n.remember-button[data-v-8a6a2b0c] {\n  float: left;\n}\n.login-form-button[data-v-8a6a2b0c] {\n  width: 100%;\n}\n", ""]);

// exports
